import { takeLatest } from 'redux-saga/effects';
import sagaActions from '../../actions/index';
import {
  fetchDashboardSaga,
  deleteVerificationSaga,
  getFeedbackSaga,
  postFeedbackSaga,
  downloadExcelSaga,
} from './superAdminDashboardSaga';

export function* superAdminDashboardSaga() {
  yield takeLatest(sagaActions.SUPER_ADMIN_DASHBOARD, fetchDashboardSaga);
  yield takeLatest(sagaActions.SUPER_ADMIN_DASHBOARD_DELETE, deleteVerificationSaga);
  yield takeLatest(sagaActions.SUPER_ADMIN_FEEDBACK_GET, getFeedbackSaga);
  yield takeLatest(sagaActions.SUPER_ADMIN_FEEDBACK_POST, postFeedbackSaga);
  yield takeLatest(sagaActions.DOWNLOAD_SUPER_ADMIN_DATA, downloadExcelSaga);
}
